import {
  EMPTY_USER_FILTERS,
  PRIMARY_TASKS,
  type PrimaryTask,
  type UserFilters,
} from '../api/types';

interface Props {
  filters: UserFilters;
  onChange: (filters: UserFilters) => void;
}

const TASK_LABELS: Record<PrimaryTask, string> = {
  page_migration: 'Migration',
  refinement: 'Refinement',
  skill_authoring: 'Skill auth',
  content_generation: 'Content gen',
  other: 'Other',
};

function toggle<T>(list: T[], value: T): T[] {
  return list.includes(value) ? list.filter((v) => v !== value) : [...list, value];
}

function intOrNull(value: string): number | null {
  if (value === '') return null;
  const n = Number.parseInt(value, 10);
  return Number.isFinite(n) && n >= 0 ? n : null;
}

function fractionOrNull(value: string): number | null {
  if (value === '') return null;
  const n = Number.parseFloat(value);
  if (!Number.isFinite(n) || n < 0 || n > 100) return null;
  return n / 100;
}

export function UsersFilterBar({ filters, onChange }: Props): JSX.Element {
  return (
    <div className="sessions-filter-bar" role="region" aria-label="User filters">
      <div className="filter-chip-group">
        <span className="filter-chip-group-label">Ran task:</span>
        {PRIMARY_TASKS.map((task) => {
          const isActive = filters.tasks.includes(task);
          return (
            <button
              key={task}
              type="button"
              className={`filter-chip${isActive ? ' is-active' : ''}`}
              onClick={() =>
                onChange({ ...filters, tasks: toggle(filters.tasks, task) as PrimaryTask[] })
              }
              aria-pressed={isActive}
            >
              {TASK_LABELS[task]}
            </button>
          );
        })}
      </div>
      <div className="filter-range-row">
        <span className="filter-chip-group-label">Sessions ≥:</span>
        <input
          type="number"
          className="filter-range-input"
          min={0}
          value={filters.minSessions === null ? '' : String(filters.minSessions)}
          onChange={(e) => onChange({ ...filters, minSessions: intOrNull(e.target.value) })}
          placeholder="any"
        />
      </div>
      <div className="filter-range-row">
        <span className="filter-chip-group-label">Completion ≥:</span>
        <input
          type="number"
          className="filter-range-input"
          min={0}
          max={100}
          value={
            filters.minCompletionRate === null
              ? ''
              : String(Math.round(filters.minCompletionRate * 100))
          }
          onChange={(e) =>
            onChange({ ...filters, minCompletionRate: fractionOrNull(e.target.value) })
          }
          placeholder="any"
        />
        <span className="filter-range-unit">%</span>
      </div>
      <button
        type="button"
        className="filter-clear"
        onClick={() => onChange(EMPTY_USER_FILTERS)}
      >
        Clear filters
      </button>
    </div>
  );
}
